import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Card, CardBody, Col, Container } from "reactstrap";
import IndividualsTable from "../../Components/Tables/IndividualsTable/IndividualsTable";
import {
  getIndividuals,
  getIndividualsByUserId,
} from "../../slices/individuals/thunk";
// import AddIndividualsModal from "../../Components/modals/IndividualsModal/AddIndividualsModal";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import ButtonAddRole from "../../Components/Buttons/ButtonAddRole.js";
import DropdownActionsTable from "../../Components/Dropdown/DropdownActionsTable.js";
import HeadersRole from "../../Components/Headers/HeadersRole.js";
import Loading from "../../Components/Loading.js";
import SearchBar from "../../Components/SearchBar/SearchBar.js";
import CommissionsIndividualsTable from "../../Components/Tables/IndividualsTable/CommissionsIndividualsTable.js";
import NavTabIndiviuals from "../../Components/Tabs/NavTabIndividuals.js";
import PromoCodeModal from "../../Components/modals/GeneralModals/PromoCodesModal.js";
import AddIndividualsModal from "../../Components/modals/IndividualsModal/AddIndividualsModal.js";
import individualsIcon from "../../assets/images/iconsRoles/IndividualsIcon.svg";
import { DASHBOARD_USER_ROLES, INDIVIDUAL_STATUS } from "../../constants/index.js";
import { useReferralLinkBuilder } from "../../hooks/useReferralLinkBuilder.js";
import { useCurrentUser } from "../../slices/auth/hooks.js";
import { setCurrentUser } from "../../slices/auth/reducer.js";
import {
  addDefaultPromoCode,
  deleteIndividualById,
} from "../../slices/general/thunk.js";
import { downloadIndividualsReportByDashboardUserId } from "../../slices/national/thunk.js";

const DashboardIndividualBooks = (props) => {
  const inputRef = useRef(null);
  const searchDebounceRef = useRef(null);
  const currentUser = useCurrentUser();
  const isAdmin = currentUser.role === DASHBOARD_USER_ROLES.ADMIN;
  const isNational = currentUser.role === DASHBOARD_USER_ROLES.NATIONAL;
  const { id } = useParams();
  const dispatch = useDispatch();
  const profileUser = props.user || currentUser;
  const isProfilePage = id;

  const { role } = currentUser;
  const [loading, setLoading] = useState(false);
  const [individuals, setIndividuals] = useState([]);
  const [isInactive, setIsInactive] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);
  const [searchDone, setSearchDone] = useState(false);
  const [lastSearchTerm, setLastSearchTerm] = useState(searchTerm);
  const [copySuccess, setCopySuccess] = useState(false);
  const [promoCodes, setPromoCodes] = useState(profileUser?.defaultPromoCode);
  const [openModalIndividual, setOpenModalAddIndividual] = useState(false);
  const [openModalPromoCodes, setOpenModalPromoCodes] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [totalIndividuals, setTotalIndividuals] = useState(0);
  const [pageSize, setPageSize] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [statusIndividual, setStatusIndividual] = useState("active");
  const [activeTab, setActiveTab] = useState("1");

  const {
    createIndividualReferralLinkFromPromoCode,
  } = useReferralLinkBuilder();

  const userReferralLink = createIndividualReferralLinkFromPromoCode(promoCodes?.code);


  const handleCopyReferralLink = () => {
    navigator.clipboard.writeText(userReferralLink);
    setCopySuccess(true);
  };

  const handleViewReferralPage = () => {
    // OPen referral link page in new tab
    window.open(userReferralLink, "_blank");
  };

  useEffect(() => {
    if (copySuccess) {
      setTimeout(() => {
        setCopySuccess(false);
      }, 2000);
    }
  }, [copySuccess]);

  const handleOpenModalPromoCodes = () => {
    setOpenModalPromoCodes(true);
  };

  const toggleTab = (tab, status) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      // Update this line to handle "terminated" state
      setIsInactive(status === INDIVIDUAL_STATUS.INACTIVE || status === INDIVIDUAL_STATUS.TERMINATED);

      setStatusIndividual(status);
      setCurrentPage(0);
    }
  };

  const handleOpenModalAddIndividual = () => {
    setOpenModalAddIndividual(true);
  };

  const fetchIndividualsById = async () => {
    setLoading(true);
    try {
      const response = await dispatch(
        getIndividualsByUserId({
          userId: id,
          status: statusIndividual,
          page: currentPage,
          query: searchTerm,
        })
      );
      setIndividuals(response.payload.data);
      setTotalIndividuals(response.payload.total);
      setTotalPages(response.payload.pages);
      setPageSize(response.payload.pageSize);
      setSearchDone(true);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const fetchIndividuals = async () => {
    setLoading(true);
    try {
      let response;

      // For National users, use the getIndividualsByUserId endpoint
      if (isNational) {
        response = await dispatch(
          getIndividualsByUserId({
            userId: currentUser.id,
            status: statusIndividual,
            page: currentPage,
            query: searchTerm,
          })
        );
      } else {
        response = await dispatch(
          getIndividuals({
            role: `dashboard${role === "admin" ? "/admin" : ""}`,
            status: statusIndividual,
            page: currentPage,
            query: searchTerm,
          })
        );
      }

      setIndividuals(response.payload.data);
      setTotalIndividuals(response.payload.total);
      setTotalPages(response.payload.pages);
      setPageSize(response.payload.pageSize);
      setSearchDone(true);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const hanldeRefreshTable = () => {
    fetchIndividuals();
  };

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    if (searchDebounceRef.current) {
      clearTimeout(searchDebounceRef.current);
    }

    searchDebounceRef.current = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => clearTimeout(searchDebounceRef.current);
  }, [searchTerm]);

  useEffect(() => {
    if (debouncedSearchTerm === lastSearchTerm) {
      setSearchDone(true);
    } else {
      setSearchDone(false);
    }
    if (isProfilePage) {
      fetchIndividualsById();
    } else {
      fetchIndividuals();
    }
  }, [
    currentPage,
    isInactive,
    statusIndividual,
    debouncedSearchTerm,
    dispatch,
  ]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  const handleAddPromoCode = async () => {
    try {
      setLoading(true);
      const response = await dispatch(addDefaultPromoCode()).unwrap();
      Swal.fire({
        icon: "success",
        title: "Promo Code Added!",
        text: `Successfully added promo code ${response.code}`,
      });
      setCurrentUser({ ...currentUser, defaultPromoCode: response });
      setPromoCodes(response);
      setLoading(false);
    } catch (error) {
      setLoading(true);
      console.log(error);
      setLoading(false);
    }
  };

  const handleDeleteIndividual = async (item) => {
    Swal.fire({
      title: `Are you sure you want to remove ${item.individualCode ? "Individual" : "Employee"
        } with email ${item.email}?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          Swal.fire({
            title: "Deleting...",
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            showConfirmButton: false,
          });

          const response = await dispatch(
            deleteIndividualById({ individualId: item.id })
          ).unwrap();

          if (response.error) {
            Swal.fire({
              title: "Oops!",
              text: `There was a problem deleting the individual ${response.error}.`,
              icon: "error",
              confirmButtonText: "Ok",
            });

            return;
          } else {
            Swal.fire(
              "Deleted!",
              "  Individual has been deleted successfully",
              "success"
            );
          }
          await fetchIndividuals();
        } catch (err) {
          console.error(err);
          Swal.fire("Error!", errorMessage, "error");
        }
      }
    });
  };

  return (
    <React.Fragment>
      {openModalIndividual && (
        <AddIndividualsModal
          open={openModalIndividual}
          setOpen={setOpenModalAddIndividual}
          onCreate={hanldeRefreshTable}
        />
      )}
      {openModalPromoCodes && (
        <PromoCodeModal
          currentUser={currentUser}
          loading={loading}
          setLoading={setLoading}
          onAddPromoCode={handleAddPromoCode}
          open={openModalPromoCodes}
          setOpen={setOpenModalPromoCodes}
          promoCodes={promoCodes}
        />
      )}
      <div className={` ${id ? "mt-1" : "page-content"}`}>
        <Container fluid className={`${id ? "p-0" : ""}`}>
          <HeadersRole role={"Individuals"} icon={individualsIcon} svg={true} />
          <Card className="mb-4 pb-3">
            <CardBody>
              <div
                style={{ paddingTop: id ? "3px" : "0px" }}
                className="col-12 d-flex justify-content-between mt-1 mb-4 align-items-center "
              >
                <div className="col-4 d-flex justify-content-end align-items-center">
                  <SearchBar
                    inputRef={inputRef}
                    value={searchTerm}
                    onChange={handleSearch}
                    placeholder="Filter by name or email"
                    shouldDisplaySearchBar={true}
                  />

                  {(isAdmin || isNational) && (
                    <DropdownActionsTable
                      downloadMethod={
                        downloadIndividualsReportByDashboardUserId
                      }
                      params={{ dashboardUserId: profileUser.id }}
                    />
                    // <DownloadReportCSVButton
                    //   downloadMethod={downloadIndividualsReportByDashboardUserId}
                    //   params={{ dashboardUserId: profileUser.id }}
                    // />
                  )}
                </div>
              </div>{" "}
              <Col xl={12}>
                <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                  <NavTabIndiviuals
                    loading={loading}
                    toggleTab={toggleTab}
                    activeTab={activeTab}
                  />

                  <div className="d-flex align-items-center flex-row flex-wrap">
                    {!isAdmin && (
                      <div className="d-flex">
                        <Button
                          onClick={handleViewReferralPage}
                          // style={{
                          //   background: 'rgba(54, 61, 72, 0.1)'
                          // }}
                          className="btn btn-soft-primary border py-2 d-flex align-items-center"
                        >
                          {/* <i className="mdi mdi-eye me-2"></i> */}
                          {/* // New tab icon */}
                          <i className="mdi mdi-open-in-new me-2"></i>
                          View your page
                        </Button>

                        <Button
                          onClick={handleCopyReferralLink}
                          className="btn btn-primary border border-primary py-2 d-flex align-items-center ms-2 me-2"
                        >
                          <i className="mdi mdi-content-copy me-2"></i>
                          {copySuccess ? "Copied!" : "Copy link"}
                        </Button>
                      </div>
                    )}

                    {!isAdmin && (
                      <ButtonAddRole
                        open={handleOpenModalAddIndividual}
                        roleToAdd="Individual"
                      />
                    )}


                  </div>
                </div>

                <div className="table-container position-relative">
                  {loading && <Loading />}

                  <div className="live-preview">
                    <div className="table-responsive ">
                      <IndividualsTable
                        data={individuals}
                        searchDone={searchDone}
                        searchParam={debouncedSearchTerm}
                        onRefreshTable={hanldeRefreshTable}
                        onEditClick={() => { }}
                        onDelete={handleDeleteIndividual}
                        paginationProps={{
                          itemsCount: individuals.length,
                          totalPages: totalPages,
                          totalItems: totalIndividuals,
                          currentPage: currentPage,
                          onChangePage: handleChangePage,
                        }}
                        isInactive={isInactive}
                        activeTab={activeTab}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </CardBody>
          </Card>
          <div className="mt-3">
            {id && isAdmin && <CommissionsIndividualsTable />}
          </div>
        </Container>
      </div>
      <div id="portal-root"></div>
    </React.Fragment>
  );
};

export default DashboardIndividualBooks;
